import type { PropsWithChildren } from 'react';

import classNames from 'classnames';

import type { MobileLayoutType } from './TableBody';

export type TableCellAlign = {
  align?: 'left' | 'right' | 'center';
};

export type HasRightPadding = {
  /**
   * Controls right padding in the table cell. Default `true`, except for the last column
   * @default false
   */
  noRightPadding?: boolean;
};

export interface TableBodyCellProps extends MobileLayoutType, TableCellAlign, HasRightPadding {
  /**
   * Padding for content slot inside `TableBodyCell`
   * @default medium
   */
  contentPadding?: 'none' | 'small' | 'medium';
}

export const TableBodyCell = ({
  children,
  noRightPadding = false,
  contentPadding = 'medium',
  isMobileLayout,
  align = 'left',
}: PropsWithChildren<TableBodyCellProps>) => (
  <div
    className={classNames('py-1', {
      'pt-3 pb-[11px]': !isMobileLayout,
      'pr-0': noRightPadding,
      'pr-4': !noRightPadding,
    })}
    data-qa="table-body-cell"
  >
    <div
      className={classNames(
        'flex items-center',
        isMobileLayout
          ? {
              'py-1': contentPadding === 'none',
              'py-0.5': contentPadding === 'medium',
            }
          : {
              'py-0': contentPadding === 'none',
              'py-1': contentPadding === 'small',
              'py-1.5': contentPadding === 'medium',
            },
        {
          'justify-start': align === 'left',
          'justify-end': align === 'right',
          'justify-center': align === 'center',
        },
      )}
      data-qa="table-body-cell-content"
    >
      {children}
    </div>
  </div>
);
